import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '個人でも依頼できますか？',
      answer: 'もちろん可能です。'
    },
    {
      question: '納品方法はPDF以外でも対応していますか？',
      answer: 'はい。ご要望に応じて、複写（郵送）・コンビニプリントもご用意しております。'
    },
    {
      question: '一度に大量注文ができますか。',
      answer: 'はい。可能です。'
    },
    {
      question: '支払方法は何がありますか',
      answer: '請求書払いとクレジットカード決済をご利用いただけます。請求書払いをご希望の場合は、納品後に請求書をお送りいたします。'
    },
    {
      question: 'キャンセルはできますか',
      answer: 'お見積りはキャンセル可能です。ご注文後のキャンセルはお受けできません'
    },
    {
      question: 'Supplementary Data（※論文の付録情報）は付属していますか？',
      answer: 'Supplementary Dataがあれば、本文のPDFファイルと一緒にお届けします。Supplemental dataはPDFを実際に入手するまで有無が確認できません。「Supplemental data がある場合のみ入手したい」などは対応致しかねます予めご了承ください。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-12">
          よくある質問
        </h2>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden hover:border-blue-300 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-start gap-4 text-left hover:bg-blue-50 transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full font-bold text-lg flex-shrink-0 mt-1">
                  Q
                </div>
                <div className="flex-1">
                  <p className="font-bold text-gray-900 text-lg">{faq.question}</p>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform flex-shrink-0 mt-1 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-4 ml-12">
                    <div className="w-8 h-8 flex items-center justify-center bg-blue-100 text-blue-600 rounded-full font-bold text-lg flex-shrink-0">
                      A
                    </div>
                    <p className="text-gray-600 leading-relaxed flex-1 pt-1">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
